export class loginError {

        expires: Date;
        hasExpired: boolean = false;
        noLicence: boolean = false;
        generalError: boolean = false;
        generalErrorText: string = '';
        isValid: boolean = false;
        noConfig: boolean = false;

        orgName: string = '';
        serialNumber: string = '';
        accountLocked: boolean;

        // Organisation the sign-in resolved to. Shown alongside the "no
        // configuration found" message so a support ticket carries the one
        // detail needed to diagnose it, rather than just "it would not let
        // me in".
        orgId: string = '';

}
